import { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { PlusIcon } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableDepartmentTag,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import Tooltip from "../../../../component/ui/tooltip";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import moment from "moment";
import { Link } from "react-router";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import StatusChip from "../../../../component/ui/chip/status";
// import Details from "./details";
// import AddPopup from "./add-popup";
import Swal from "sweetalert2";
import AvatarProfile from "../../../../component/ui/profile";
import { TitleHeading } from "../../../../component/ui/layout";

const FuelTrendList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [lists, setList] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [tableHeaders, setTableHeaders] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  // const [currentData, setCurrentData] = useState({});
  // const [addModal, setAddModal] = useState(false);
  // const [isShowModal, setIsShowModal] = useState(false);
  const [dropdowns, setDropdowns] = useState({});
  const [customYear, setCustomYear] = useState(moment().format("YYYY"));
  const [isMothlyLoading, setIsMothlyLoading] = useState(true);
  const [monthlyData, setMonthlyData] = useState({})

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getDropdowns()
  }, []);

  const getData = async ({ filter = filterReturn, page = "" }) => {
    if (!page) {
      setIsLoading(true);
    }
    let extraUrl = `?page=${page}`;
    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.selectedOpt == "between") {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value[0]}_${filter[i]?.value[1]}`;
      } else {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }
    try {
      const res = await apiCall({
        method: "get",
        url: `get-year-over-year-fuel-summary${extraUrl}`,
      });
      if (page) {
        setList((prev) => [...prev, ...res.data]);
      } else {
        setList(res.data);
      }

      setTableHeaders(res.headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  // const [listLocation, setListLocation] = useState([]);
  const getDropdowns = async () => {
    try {
      let apiRes = await apiCall({ method: "get", url: "create-asset?type=generator_fuel" })
      setDropdowns(apiRes)

      // const res = await apiCall({ method: "get", url: "locations-list" });
      // setListLocation(res?.data);
    } catch (error) {
      console.log("Error", error)
    }
  };

  const getMonthlyData = async () => {
    setIsMothlyLoading(true);
    try {
      let apiRes = await apiCall({ method: "get", url: `get-monthly-fuel-trends?year=${customYear}` })
      setMonthlyData(apiRes);
      setIsMothlyLoading(false)
    } catch (error) {
      console.log("Err", error)
    }
  }

  // const onSuccess = (message) => {
  //   setAlertData({ isShow: true, type: "success", message: message });
  //   getData({});
  //   setCurrentData({});
  //   setAddModal(false);
  // };

  // const onError = (message) => {
  //   setAlertData({ isShow: true, type: "error", message: message });
  // };

  useEffect(() => {
    getMonthlyData()
  }, [customYear])

  const filterModalData = [
    {
      name: "vendor_id",
      label: "Vendor",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: dropdowns?.vendors,
      dropdownKey: "full_name",
      dropdownVal: "id",
    },
    {
      name: "bill_receipt_number",
      label: "Bill Receipt Number",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "notes",
      label: "Notes",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "date_range",
      label: "Date Range",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "date",
      type: "date",
    },
    {
      name: "liters_filled",
      label: "Liters Filled",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "number",
      type: "number",
    },
    {
      name: "bill_amount",
      label: "Bill Amount",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "number",
      type: "number",
    },
    {
      name: "cost_per_liter",
      label: "Cost Per Liter",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "number",
      type: "number",
    },
    {
      name: "generator_hours",
      label: "Generator Hours",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      betweenType: "number",
      type: "number",
    }
  ];
  const [selectFilterName, setSelectFilterName] = useState('My Filter')
  const [editingFilters, setEditingFilters] = useState(null)

  // const editDetail = (ele) => {
  //   setCurrentData(ele);
  //   setAddModal(true);
  // };

  const tableRef = useRef(null);

  return (
    <>
      <div className={Style.leaveMainPage}>
        <div className={Style.report_table__header}>
          <span className={Style.report_table__title}>
            <TitleHeading title={`Monthly Trends`} />
          </span>

          <div className={Style.bpfl_action}>
          </div>
        </div>

        <div className={Style.LeaveBody}>
          {(isLoading || isMothlyLoading) ? (
            <InnerLoader />
          ) : (
            <>
              <TableCard ref={tableRef}>
                <div className={"flex flex-col gap-6"}>
                  {
                    !lists?.length ?
                    <DataNotFound title={"Yearly Data"} />
                    :
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell header sticky>
                            <div className="flex gap-4 items-center">
                              <span>Year</span>
                            </div>
                          </TableCell>
                          {tableHeaders?.map((eachHead, index) =>
                            eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                              <TableCell header key={index}>
                                <TableHeaderWrap>
                                  <span>{eachHead?.value}</span>
                                </TableHeaderWrap>
                              </TableCell>
                            ) : null
                          )}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {lists?.map((eachList, index) => {
                          return (
                            <TableRow key={`${index}`}>
                              <TableCell sticky>
                                <div className={`${Style.tableActionArea} !gap-4`}>
                                  <div className="flex gap-[10px]">
                                    <div className="flex items-center gap-3">
                                      <div className="font-semibold text-[15px] leading-5 underline decoration-dotted cursor-pointer underline-offset-4" onClick={() => {setCustomYear(eachList?.year)}}>{eachList?.year}</div>
                                    </div>
                                  </div>

                                  {/* <div className={Style.tableActionAreaBtnGrpup}>
                                    <div
                                      className={
                                        "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                      }
                                      onClick={() => {
                                        editDetail(eachList);
                                      }}
                                    >
                                      <div
                                        className={Style.icon}
                                        style={{ color: "#FF9500" }}
                                      >
                                        <NewEditIcon className="h-4.5 w-4.5" />
                                      </div>
                                    </div>
                                  </div> */}
                                </div>
                              </TableCell>

                              {tableHeaders?.map((eachHead, i) =>
                                eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                                  <>
                                    {eachHead.key === "status" ? (
                                      <TableCell
                                        key={`${i}-${index}`}
                                        className={`text-center`}
                                      >
                                        {eachList[eachHead?.key] === "Assigned" ? (
                                          <StatusChip color="green">{eachList[eachHead?.key] || "--"}</StatusChip>
                                        ) : eachList[eachHead?.key] === "Retired" ? (
                                          <StatusChip color="red">{eachList[eachHead?.key] || "--"}</StatusChip>
                                        ) : eachList[eachHead?.key] === "Under Repair" ? (
                                          <StatusChip color="purple">{eachList[eachHead?.key] || "--"}</StatusChip>
                                        ) : (
                                          <StatusChip color="blue">{eachList[eachHead?.key] || "--"}</StatusChip>
                                        )}
                                      </TableCell>
                                    ) : eachHead.key === "assigned_to_department" ? (
                                      <TableCell key={`${i}-${index}`}>
                                        <div className="flex flex-wrap gap-2 max-w-[550px]">
                                          {eachList?.assigned_to_department ? (
                                            eachList.assigned_to_department.split(",").map((dep, index) => (
                                              <TableDepartmentTag
                                                title={dep.trim()}
                                              />
                                            ))
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </TableCell>
                                    ) : eachHead.key === "assigned_to_designation" ? (
                                      <TableCell key={`${i}-${index}`}>
                                        <div className="flex flex-wrap gap-2 max-w-[550px]">
                                          {eachList?.assigned_to_designation ? (
                                            eachList?.assigned_to_designation.split(",").map((des, index) => (
                                              <span>{des.trim()}</span>
                                            ))
                                          ) : (
                                            "-"
                                          )}
                                        </div>
                                      </TableCell>
                                    ) : eachHead.key === "created_by" ? (
                                      <TableCell key={`${i}-${index}`}>
                                        <AvatarProfile
                                          title={eachList?.created_by}
                                          src={eachList?.created_by_profile_picture?.split(",")[index]?.trim()}
                                        />
                                      </TableCell>
                                    ) : (
                                      <TableCell key={`${i}-${index}`}>
                                        {(eachList[eachHead?.key]) ? (typeof eachList[eachHead?.key] == "string" && eachList[eachHead?.key]?.slice(0, 5) == "https") ? <Link to={eachList[eachHead?.key]} target="_blank" className="text-blue-600 underline">View</Link> : eachList[eachHead?.key] : "-"}
                                      </TableCell>
                                    )}
                                  </>
                                ) : null
                              )}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  }

                  {!monthlyData?.data?.length ?
                    <DataNotFound title={"Monthly Data"} />
                    :
                    <>
                      <TitleHeading title={`Monthly Fuel Summary (${customYear ? customYear : moment().format("YYYY")})`} />
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <div className="flex gap-4 items-center">
                                <span>Month</span>
                              </div>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>{"Total Liters"}</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>{"Total Cost"}</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>{"Avg Cost Per Liter"}</span>
                              </TableHeaderWrap>
                            </TableCell>

                            <TableCell header>
                              <TableHeaderWrap>
                                <span>{"MOM Change"}</span>
                              </TableHeaderWrap>
                            </TableCell>
                            {/* {tableHeaders?.map((eachHead, index) =>
                          eachHead.is_visible === 1 && eachHead?.show == 1 ? (
                            <TableCell header key={index}>
                              <TableHeaderWrap>
                                <span>{eachHead?.value}</span>
                              </TableHeaderWrap>
                            </TableCell>
                          ) : null
                        )} */}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {monthlyData?.data?.map((eachList, index) => {
                            return (
                              <TableRow key={`${index}`}>
                                <TableCell sticky>
                                  <div className={`${Style.tableActionArea} !gap-4`}>
                                    <div className="flex gap-[10px]">
                                      <div className="flex items-center gap-3">
                                        <div className="font-semibold text-[15px] leading-5">{eachList?.month}</div>
                                      </div>
                                    </div>
                                  </div>
                                </TableCell>

                                <TableCell>
                                  {eachList?.total_liters}
                                </TableCell>

                                <TableCell>
                                  {eachList?.total_cost}
                                </TableCell>

                                <TableCell>
                                  {eachList?.avg_cost_per_liter}
                                </TableCell>

                                <TableCell>
                                  {eachList?.mom_change}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </>
                  }
                </div>
              </TableCard>
            </>
          )}
        </div>

        {!isLoading ? (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              {`showing 1 to ${lists?.length} of ${tablePagination?.total || lists?.length
                }`}
            </div>

            {tablePagination ? (
              <div className={Style.empDirectory_footer}>
                {tablePagination?.next_page_url ? (
                  <button
                    className={Style.loadMoreBtn}
                    onClick={() => {
                      if (btnLoader) return;
                      // setPageCount(pageCount + 1);
                      setBtnLoader(true);
                      // filterData({ page: pageCount + 1, btnCall: true });
                      getData({ page: tablePagination?.next_page_url });
                    }}
                  >
                    {btnLoader ? (
                      <InnerLoader
                        className={Style.loader}
                        textStatus={false}
                      />
                    ) : (
                      "Load More"
                    )}
                  </button>
                ) : null}
              </div>
            ) : null}

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        ) : (
          <div className={Style.table_footer} style={{ alignItems: "center" }}>
            <div className={Style.table_footer_left}>
              <Skeleton width={"50%"} height={15} />
            </div>

            <div className={Style.empDirectory_footer}>
              <Skeleton width={"180px"} height={40} />
            </div>

            <div
              className={`${Style.table_footer_left} ${Style.rightText}`}
            ></div>
          </div>
        )}
      </div>

      {/*{showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            setShowModalFilterTable(false);
            setFilterReturn(filters);
            setSelectFilterName(filterName);
            setEditingFilters(editingFilter);
            getData({ filter: filters });
          }}
          selectFilterName={selectFilterName}
          editingFilters={editingFilters}
          saveFilter={saveFilter}
          apiUrl="assets-list"
        />
      )} */}

      {/* {addModal &&
        <AddPopup currentData={currentData} onClose={() => { setAddModal(false); setCurrentData({}) }} onError={onError} onSubmit={onSuccess} dropdowns={dropdowns} />
      } */}


      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeaders}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeaders(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeaders(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="assets-list"
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FuelTrendList;
